import { all, call, delay, fork, put, takeLatest } from "redux-saga/effects";
import * as Types from 'constants/Types';
import * as Func from "helpers/functions";
import * as AppUIService from 'services/appService'
import i18n from 'constants/initLng';
import { PATHS, SAGA_DELAY_TIMEOUT } from "constants/Define";
import history from "helpers/history";
import AppModel from 'models/AppUI'


function* createNewAppUI() {
    yield takeLatest(Types.APP_UI_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(AppUIService.createNewAppUIConfig, action?.appUI);
        Func.sagaSuccessMessage({action, message: `${i18n.t('notification.createSuccess')}`});
        yield put({type: Types.APP_UI_CREATE_SUCCESS});
        yield delay(SAGA_DELAY_TIMEOUT);
        history.push(PATHS.APP.LIST.path);
        history.go();
    },errHandleAppUI(Types.APP_UI_CREATE_FAIL)))
}

function* updateAppUIConfig() {
    yield takeLatest(Types.APP_UI_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(AppUIService.updateAppUIConfig,action?.appUI);
        Func.sagaSuccessMessage({action, message: `${i18n.t('notification.updateSuccess')}`});
        yield put({type: Types.APP_UI_UPDATE_SUCCESS});
        yield delay(SAGA_DELAY_TIMEOUT);
        history.push(PATHS.APP.LIST.path);
        history.go();
    },errHandleAppUI(Types.APP_UI_UPDATE_FAIL)))
}

function* deleteAppUIConfig() {
    yield takeLatest(Types.APP_UI_DELETE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(AppUIService.deleteAppUIConfig, action?.id);
        Func.sagaSuccessMessage({action, message: `${i18n.t('notification.removeSuccess')}`});
        yield put({type: Types.APP_UI_DELETE_SUCCESS});
        yield put({type: Types.APP_UI_RELOAD_DATA})
    }, errHandleAppUI(Types.APP_UI_DELETE_FAIL)))
}

function* deleteWhitelistIp() {
    yield takeLatest(Types.WHITELIST_IP_DELETE_IP, Func.sagaWrapper(function* (action) {
        yield call(AppUIService.deleteIp, action?.id);
        Func.sagaSuccessMessage({action, message: `${i18n.t('notification.removeSuccess')}`});
        yield put({type: Types.WHITELIST_IP_DELETE_IP_SUCCESS});
        yield put({type: Types.APP_UI_RELOAD_DATA})
    }, errHandleAppUI(Types.WHITELIST_IP_DELETE_IP_FAIL)))
}

function* createWhitelistIp() {
    yield takeLatest(Types.WHITELIST_IP_CREATE_IP, Func.sagaWrapper(function* (action) {
        yield call(AppUIService.createIp, action?.ipData);
        Func.sagaSuccessMessage({action, message: `${i18n.t('notification.createSuccess')}`});
        yield put({type: Types.WHITELIST_IP_CREATE_IP_SUCCESS});
        yield delay(SAGA_DELAY_TIMEOUT);
        history.push(PATHS.APP.WHITELIST.path);
        history.go();
    },errHandleAppUI(Types.WHITELIST_IP_CREATE_IP_FAIL)))
}

function* createNewAppTranslation() {
    yield takeLatest(Types.APP_UI_CREATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(AppUIService.createAppUITranslate, action?.appUI);
        Func.sagaSuccessMessage({action, message: `${i18n.t('notification.updateSuccess')}`});
        yield put({type: Types.APP_UI_CREATE_TRANSLATE_SUCCESS});
        yield put({type: Types.APP_UI_RELOAD_DATA})
    }, errHandleAppUI(Types.APP_UI_CREATE_TRANSLATE_FAIL)))
}

function* updateAppTranslation() {
    yield takeLatest(Types.APP_UI_UPDATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(AppUIService.updateAppUITranslate, action.appUI);
        Func.sagaSuccessMessage({action, message: `${i18n.t('notification.updateSuccess')}`});
        yield put({type: Types.APP_UI_UPDATE_TRANSLATE_SUCCESS});
        yield put({type: Types.APP_UI_RELOAD_DATA})
    }, errHandleAppUI(Types.APP_UI_UPDATE_TRANSLATE_FAIL)))
}

function* deleteAppTranslation() {
    yield takeLatest(Types.APP_UI_DELETE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        const idTranslation = action.appUI.translations.find(el => el.languageCode === action.appUI.languageCode).id;
        yield call(AppUIService.deleteAppUITranslate, idTranslation);
        Func.sagaSuccessMessage(action, i18n.t('notification.removeSuccess'), action.appUI.languageCode);
        yield put({type: Types.APP_UI_DELETE_TRANSLATE_SUCCESS});
        yield put({type: Types.APP_UI_RELOAD_DATA})
    }, errHandleAppUI(Types.APP_UI_DELETE_TRANSLATE_FAIL)))
}

function errHandleAppUI(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        const errorActionTypeArray = ['WHITELIST_IP_DELETE_IP_FAIL', 'WHITELIST_IP_CREATE_IP_FAIL'];
        if (!errorActionTypeArray.includes(errorActionType)) {
            yield put({type: errorActionType},'appUI')
        }
    })
}

export function* appUISaga() {
    yield all([
        fork(createNewAppUI),
        fork(updateAppUIConfig),
        fork(deleteAppUIConfig),
        fork(deleteWhitelistIp),
        fork(createWhitelistIp),
        fork(createNewAppTranslation),
        fork(updateAppTranslation),
        fork(deleteAppTranslation)
    ])
}
